import { DatePipe } from '@angular/common';
import { Component,Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DashboarduiService } from 'src/app/components/Shared/Service/dashboardui.service';
import { LocalstorageService } from 'src/app/components/Shared/Service/localstorage.service';
import { MatSelectChange } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
declare var $: any; 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: any;
  status: any;
  // hotelName: any;
  accountingDate: any;
  pusheddate: any;
  type:any
}
@Component({
  selector: 'app-heartbeat-logs',
  templateUrl: './heartbeat-logs.component.html',
  styleUrls: ['./heartbeat-logs.component.css'],
  providers: [DashboarduiService,
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class HeartbeatLogsComponent {
  searchText:any;
  typ:any;
  public PGF: any = "0";
  public PGT: any = "50";
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 250, 500];
  url: any;
  pmscode: any;
  filterProperty: any;
  displayContent: boolean;
  errorMsgSubscription: boolean;
  errorMessage: string;
  constructor(private toastr: ToastrService,public router:Router,private apiCallIdsService: DashboarduiService, private datePipe: DatePipe, private localStorage: LocalstorageService) { 

  }
  
  display: Boolean = false;
  totalcount: any = 0;
  idsProductList: idsProductList[] = [];
  dataSource!: MatTableDataSource<idsProductList>;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort!: MatSort;
  Val: any;
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  displayedColumns: string[] = ['startDate','endDate','minDiffs'];
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any
  ngOnInit() {
    this.isProgressing = true;
      this.callPropertyList();
        this.dropdownSettingsDept = {
          idField: 'pmscode',
          textField: 'pmsname',
          allowSearchFilter: true,
          singleSelection: true,
          enableCheckAll: false,
          closeDropDownOnSelection: true,
          itemsShowLimit: 7,
          noDataAvailablePlaceholderText: 'No Data Found',
          searchPlaceholderText: "Search Property"
        };
      
  }


  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property"
        this.displayContent = false
        this.pmscode = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.pmscode)
        this.LoadMethod()

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  callPropertyList(){
    this.apiCallIdsService.getHeartbeatLogPropList()
      .subscribe(
        data => {
          console.log('property list =', data)
          this.dropdownDeptData = data
          this.isProgressing = false
        },
        );
  }


  LoadMethod(){
    this.isProgressing = true
    this.apiCallIdsService.getHeartbeatLogList(this.pmscode)
      .subscribe(
        data => {
          console.log('getHeartbeatLogList == ', data)
          if(data.length > 0){
            this.idsProductList=data;
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.errorMsgSubscription = false
              this.displayContent = true
            this.toastr.success('Data Loaded Successfully');
            this.isProgressing=false;
          }else {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          
        },
        );
  }

  pageEvent(e:any) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } 
  Search(event:any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelInfo: { toString: () => string; }}) => {
      return res.hotelInfo.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if(event == ''){
      this.Val = '';
      // this.isProgressing = true
      this.LoadMethod();
    }
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
}

